export default "__VITE_ASSET__78a52433__"